export const ROLE_OPERATEUR_FORM_NAME = "roleOperateurId";
export const OPERATEUR_FORM_NAME = "operateurId";
export const UTILISATEUR_FORM_NAME = "user";
export const ID_TRANSACTION_FORM_NAME = "idTransaction";
export const CRITERE_FACTURATION_FORM_NAME = "critereFacturation";
export const REFERENCE_DECLENCHEUR_FORM_NAME = "refDeclancheur";
export const STATUT_TRANSACTION_FORM_NAME = "statutTransaction";
export const CODE_PACKAGE_FORM_NAME = "codePackage";
export const NUMERO_SOUSCRIPTION_FORM_NAME = "numeroSouscription";
export const MOTIF_ANNULATION_FORM_NAME = "motifAnnulationId";
export const DATE_DE_FORM_NAME = "dateFrom";
export const DATE_A_FORM_NAME = "dateTo";
export const ANNULATION_ID_TRANSACTION_FORM_NAME = "idTransaction";
export const ANNULATION_MOTIF_ANNULATION_FORM_NAME = "idMotifAnnulation";
